import demo from "./demo";
import curriculum from "./curriculum";

const schemes = {
  curriculum,
  demo
}

export default schemes